/* eslint-disable react/jsx-no-bind */
// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Dialog,
    DialogHeader,
    DialogFooter,
    DialogContent,
    Button,
    Heading
} from '@locus-taxy/neo-ui';

import PersonnelTypeInput from './PersonnelTypeInput';
import {
    type PersonnelTypeEnumType,
    PersonnelTypeEnum
} from 'common/enums/PersonnelEnums';

type Props = {
    render: (type: PersonnelTypeEnumType) => React.Node,
    onDismiss?: () => void
};

const PersonnelTypeModalSelector = ({
    render,
    onDismiss
}: Props): React.Node => {
    const { t } = useTranslation();
    const [type, setType] = React.useState(PersonnelTypeEnum.CLIENT);
    const [isTypeSelected, setIsTypeSelected] = React.useState(false);

    return (
        <>
            <Dialog
                isOpen={!isTypeSelected}
                width="small"
                onDismiss={() => onDismiss?.()}
            >
                <DialogHeader>
                    <Heading size="large">
                        {t(
                            'entityManagement:masterPersonnelProperties.personnelType'
                        )}
                    </Heading>
                </DialogHeader>
                <DialogContent>
                    <PersonnelTypeInput
                        value={type}
                        onChange={type =>
                            setType(type ?? PersonnelTypeEnum.CLIENT)
                        }
                    />
                </DialogContent>
                <DialogFooter>
                    <Button
                        appearance="solid"
                        palette="primary"
                        onClick={() => setIsTypeSelected(true)}
                    >
                        {t('done')}
                    </Button>
                </DialogFooter>
            </Dialog>
            {isTypeSelected ? render(type) : null}
        </>
    );
};

export default PersonnelTypeModalSelector;
